import { createSlotRecipe } from './runtime';

const tabsConfig = {"name":"tabs","slots":["root","list","trigger","count","panel"]}

export const tabs = /* @__PURE__ */ createSlotRecipe(tabsConfig)